<script>
  export let active;
  export let icon;

  $: fill = active ? "#40798C" : "#1f363d";
  let stroke = "none";
</script>

<svg class="icon" {fill} {stroke}>
  <use xlink:href="#{icon}" />
</svg>

<style>
  .icon {
    width: 25px;
    height: 25px;
  }
</style>
